import React from "react";
import { motion } from "framer-motion";
import r34 from "../assets/images/r34.jpg";

const fadeDiagonal = {
  hidden: { opacity: 0, x: -80, y: 40 },
  visible: { opacity: 1, x: 0, y: 0, transition: { duration: 1, ease: "easeOut" } },
};

const About = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-orange-50 via-white to-orange-100 overflow-hidden">
      {/* Decoraciones en el fondo */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-300/20 blur-3xl rounded-full -z-10 animate-pulse" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-200/30 blur-3xl rounded-full -z-10 animate-pulse delay-1000" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">

        {/* Encabezado */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-extrabold tracking-wide text-gray-900 drop-shadow-lg">
            Acerca de <span className="text-orange-600">Nosotros</span>
          </h2>
          <p className="mt-4 text-gray-700 text-lg max-w-2xl mx-auto">
            {`Dedicados a proveer granos y semillas a las familias mexicanas, desde 1993.\n\nNuestros principales clientes son centrales de abastos de la república.`}
          </p>
        </motion.div>

        <div className="flex flex-col lg:flex-row items-center gap-14">
          {/* Imagen con efecto glass */}
          <motion.div
            initial={{ opacity: 0, scale: 0.85, rotate: -5 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative w-full lg:w-1/2"
          >
            <div className="absolute inset-0 bg-white/10 backdrop-blur-lg rounded-3xl border border-white/20 shadow-xl" />
            <img
              src={r34}
              alt="Granos"
              className="rounded-3xl shadow-2xl object-cover w-full h-[850px] relative z-10"
            />
          </motion.div>

          {/* Contenido con bloques diagonales */}
          <div className="w-full lg:w-1/2 space-y-8">
           { [
              {
                title: "Misión Almacenes Vaca",
                text: "Almacenes Vaca, es una empresa competitiva en el mercado nacional, basada en valores y una cultura de trabajo, que nos permite desarrollar todos los procesos de una forma adecuada dentro de un sistema de calidad e inocuidad. Lo más importante para nosotros son nuestros colaboradores, clientes y proveedores.",
              },
              {
                title: "Visión",
                text: "Lograr mayor penetración de mercado en diversas zonas de nuestro país y en el extranjero, para así ofrecer un mayor número de posibilidades a todos nuestros clientes.",
              },
              {
                title: "Valores",
                text: "Colaboración, Honestidad, Confianza, Responsabilidad, Lealtad y Ética.",
              },
              {
                title: "Política de Inocuidad",
                text: "En Almacenes Vaca estamos comprometidos con nuestros clientes, cumpliendo con su requerimientos y requisitos legales; garantizando la inocuidad de nuestros productos, manteniendo mecanismos eficaces de comunicación interna y externa; buscando siempre la mejora continua y el desarrollo en capacitación de nuestro personal; fomentando una responsabilidad social con el medio ambiente.",
              },
            ].map((item, i) => (
              <motion.div
                key={i}
                variants={fadeDiagonal}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: i * 0.2 }}
                className="relative p-6 rounded-2xl shadow-lg border border-white/20 backdrop-blur-xl bg-white/60 hover:scale-105 hover:shadow-xl transition-all duration-500"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-700 leading-relaxed">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
